import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";

import { createProducts } from "../fefoApi";
import FefoDialog from "./FefoDialog";

interface CreateProductModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const CreateProductModal: React.FC<CreateProductModalProps> = ({ isOpen, onClose }) => {
  const [nomeProduto, setNomeProduto] = useState("");
  const [sap, setSap] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setNomeProduto("");
      setSap("");
      setError(null);
    }
  }, [isOpen]);

  const canSubmit = !isLoading && nomeProduto.trim() !== "" && sap.trim() !== "";

  const handleCreateProduct = async (e?: React.FormEvent) => {
    e?.preventDefault();
    if (!canSubmit) return;
    setIsLoading(true);
    setError(null);

    try {
      await createProducts([{ nomeProduto: nomeProduto.trim(), sap: sap.trim() }]);
      toast.success("Produto cadastrado.");
      onClose();
    } catch (err) {
      setError(err instanceof Error ? err.message : "Erro ao cadastrar produto. Tente novamente.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <FefoDialog
      isOpen={isOpen}
      title="Cadastrar produto"
      description="Produto usado na leitura das planilhas, identificado pelo código SAP."
      onClose={onClose}
      actions={
        <>
          <button type="button" className="ecoBtn" onClick={onClose} disabled={isLoading}>
            Cancelar
          </button>
          <button type="submit" form="fefo-produto" className="ecoBtn ecoBtn--primary" disabled={!canSubmit}>
            {isLoading ? "Cadastrando..." : "Cadastrar"}
          </button>
        </>
      }
    >
      <form id="fefo-produto" className="fefoForm" onSubmit={handleCreateProduct}>
        <div className="ecoField">
          <label htmlFor="fefo-produto-nome">Nome do produto</label>
          <input
            id="fefo-produto-nome"
            className="ecoInput"
            type="text"
            value={nomeProduto}
            onChange={(e) => setNomeProduto(e.target.value)}
          />
        </div>
        <div className="ecoField">
          <label htmlFor="fefo-produto-sap">Código SAP</label>
          <input
            id="fefo-produto-sap"
            className="ecoInput"
            type="text"
            value={sap}
            onChange={(e) => setSap(e.target.value)}
          />
        </div>
        {error ? (
          <p className="fefoError" role="alert">
            {error}
          </p>
        ) : null}
      </form>
    </FefoDialog>
  );
};

export default CreateProductModal;
